import { ApiEmailTemplateGetCommunicationLogsGetRequest, ApiEmailTemplateGetMailContentByMessageIdGetRequest, ApiEmailTemplatePreviewMailBodyPostRequest, ApiEmailTemplateSendMailToExternalPostRequest, ApiEmailTemplateSendSmsToExternalPostRequest, EmailTemplateApi, WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto, WebApiServicesDataTransferObjectsEmailServiceUpdateEmailTemplateDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class EmailTemplateService {
    public static CreateTemplate = async (request: WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplatePost({
            webApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto: request
        });
    };

    public static GetTemplates = async () => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateGet();
    };

    public static GetOneFrontTemplates = async () => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateOneFrontTemplatesGet();
    };


    public static DeleteTemplate = async (templateId: number) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateTemplateIdDelete({
            templateId: templateId
        });
    };

    public static EditTemplate = async (request: WebApiServicesDataTransferObjectsEmailServiceUpdateEmailTemplateDto) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateUpdatePost({
            webApiServicesDataTransferObjectsEmailServiceUpdateEmailTemplateDto: request
        });
    };

    public static SendMailToExternal = async (request: ApiEmailTemplateSendMailToExternalPostRequest) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateSendMailToExternalPost(
            request,
            async ({ init }) => {
                if (!(init.body instanceof FormData)) {
                    return init;
                }

                const mappedValue = Number(request.designEmailDesignTemplate);
                if (Number.isInteger(mappedValue)) {
                    init.body.delete("Design.EmailDesignTemplate");
                    init.body.append("Design.EmailDesignTemplate", String(mappedValue));
                }

                return {
                    ...init,
                    body: init.body
                };
            }
        );
    };

    public static SendSmsToExternal = async (request: ApiEmailTemplateSendSmsToExternalPostRequest) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateSendSmsToExternalPost(
            request
        );
    };

    public static GetEmailLogs = async (request: ApiEmailTemplateGetCommunicationLogsGetRequest) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateGetCommunicationLogsGet(
            request
        );
    };

    public static GetMailContent = async (request: ApiEmailTemplateGetMailContentByMessageIdGetRequest) => {
        return new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplateGetMailContentByMessageIdGet(
            request
        );
    };

    public static PreviewEmail = async (request: ApiEmailTemplatePreviewMailBodyPostRequest): Promise<string> => {
        const response = await new EmailTemplateApi(GetApiConfiguration()).apiEmailTemplatePreviewMailBodyPostRaw(
            request
        );

        return response.raw.text();
    };
};
